import { AppStoreState } from '../../appStore';

export const loginScreenSelector = (state: AppStoreState) =>
  state.user.setUserData;
